module.exports = __webpack_public_path__ + "static/hoot-760f56af4c259ca8451aa11b259219c8.png";